// Facility-first homepage (COM-984 #2): "Select Kitchen" is the site's best
// converter — people commit to a place, not a concept — so the kitchens get
// prime homepage real estate. Real photos + copy from data/facilityPages.ts;
// tiles link to the facility landing pages, whose Apply preselects the kitchen.
// Deliberately NO pricing (Jeffrey).
import React from 'react';
import { Link } from 'react-router-dom';
import { FACILITIES } from '../data/facilityPages';
import './FacilityTiles.css';

const FacilityTiles: React.FC = () => (
  <section className="facility-tiles">
    <div className="container">
      <h2>Which kitchen is near you?</h2>
      <p className="facility-tiles-sub">Pick a kitchen to see the facility, the equipment, and how to apply.</p>
      <div className="facility-tiles-grid">
        {Object.values(FACILITIES).map((f) => (
          <Link key={f.slug} to={`/kitchens/${f.slug}`} className="facility-tile">
            <img src={f.image} alt={f.name} loading="lazy" />
            <span className="facility-tile-body">
              <strong>{f.name}</strong>
              {f.status === 'coming-soon' ? (
                <span>Coming soon</span>
              ) : (
                <>
                  {/* Street line, then city. Same shape as the application form's kitchen
                      list (CMSY-91): "Vancouver" alone does not tell someone whether a
                      kitchen is a twenty-minute drive or a five-minute walk, and five of
                      the six tiles say Vancouver. The street is what distinguishes them. */}
                  <span className="facility-tile-street">{f.address.split(',')[0].trim()}</span>
                  <span>{f.address.split(',').slice(-2, -1)[0]?.trim() || f.address}</span>
                </>
              )}
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default FacilityTiles;
